import isUserLoggedIn from "@Middleware/isUserLoggedIn";

const AppSettingsPage = () => import(/* webpackChunkName: 'dashboard'*/ "@Components/layouts/app/settings/index.vue");
const AppSettingsMenu = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/SettingsMenu.vue");
const PurchaseDomains = () => import(/* webpackChunkName: 'purchase' */ "@Components/layouts/app/PurchaseDomains.vue");
const PurchaseCart = () => import(/* webpackChunkName: 'purchase-cart' */ "@Components/cart/Cart.vue");

export default {
  path: "/app/purchase",
  name: "purchase",
  component: AppSettingsPage,
  redirect: { name: "purchase.domain" },
  children: [
    {
      path: "domain",
      name: "purchase.domain",
      meta: { middleware: [isUserLoggedIn] },
      components: {
        menu: AppSettingsMenu,
        main: PurchaseDomains,
      },
    },
    {
      path: "domain/cart",
      name: "purchase.domain.cart",
      meta: { middleware: [isUserLoggedIn] },
      components: {
        menu: AppSettingsMenu,
        main: PurchaseDomains,
        right: PurchaseCart,
      },
    },
  ],
};
